import React, { useEffect } from "react";
import { addToDataLayerGTM } from "../../utils/addToDataLayerGTM";

import {
  BannerSlide,
  UtilLinks,
  Recommended,
  MostWatched,
  Highlights
} from "./components";

const Home = () => {
  useEffect(() => {
    // Google Tag Manager
    const dataLayer = {
      'event': 'step_change',
      'etapa': '/home/'
    };
    addToDataLayerGTM(dataLayer);
  }, []);

  return (
    <div>
      <BannerSlide />
      <UtilLinks />
      <Recommended />
      <MostWatched />
      <Highlights />
    </div>
  );
};
export default Home;



// WEBPACK FOOTER //
// ./src/views/Home/Home.jsx